import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase.js";

export const submitBanquetEnquiry = async ({ banquetId, banquetName, customerName, customerPhone, preferredDate }) => {
  await addDoc(collection(db, "banquetEnquiries"), {
    banquetId: banquetId || "",
    banquetName: banquetName || "",
    customerName,
    customerPhone,
    preferredDate: preferredDate || null,
    submittedAt: serverTimestamp(),
  });
};
